import { UpdateBeneficiaryServiceResponse } from '@pages/approveBeneficiary/types';
import BuildNewContactService from '@pages/clients/services/buildNewContact.service';
import { formatFullName } from '@utils/formater';

const useBuildPending = () => {
  const buildNewContact = new BuildNewContactService();

  const buildPending = (data: any) => {
    const formattedUser = buildNewContact.build(data);
    const {
      contactNaturalPersonEnterprise,
      email,
      enterpriseAddress,
      enterpriseBankAccount,
    } = formattedUser || {};
    const { naturalPerson, enterprise } = contactNaturalPersonEnterprise || {};
    const { firstName, lastName } = naturalPerson || {};
    const { country } = enterprise || {};
    const { routingNumber, accountNumber, accountType, bankName } =
      enterpriseBankAccount || {};

    const legalName = formatFullName(firstName, lastName, enterprise?.name);

    const pending: UpdateBeneficiaryServiceResponse = {
      transactionType: accountType || '',
      bankName: bankName || '',
      accountNumber,
      routingNumber: routingNumber || '',
      accountType: accountType || '',
      legalName,
      country,
      address: enterpriseAddress.addressLine1 || '',
      phone: naturalPerson.phoneNumber || '',
      email,
    };
    return pending;
  };

  return { buildPending };
};

export default useBuildPending;
